import { Component, Prop } from "vue-property-decorator";
import { VueBase } from "../../Controls/VueBase";

@Component
export default class FiltreDate extends VueBase {
	@Prop()
	public columns: any;

	public operator = "";
	public valueDate = "";
	public baseId: string = "FiltreDate" + Math.random().toString(36).slice(2);

	private FieldsChanged(columns: any): void {
		if (this.operator != "") {
			this.$emit("filtre-sent", {
				Filtre: columns,
				Operator: this.operator,
				Value: (this.columns.Filter.Type === "Date") ? this.valueDate.replace("/", "-") : this.valueDate
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/FiltreDate/FiltreDate.ts